import type { AllocationComparisonBlock as Block } from './types'
import { BlockShell } from './BlockShell'
import { AllocationComparison } from '../../charts/AllocationComparison'
import type { BlockAction } from './BlockActionsMenu'

interface Props {
  block: Block
  selected: boolean
  frozen: boolean
  animate: boolean
  actions: BlockAction[]
  onToggleSelect: (id: string) => void
}

export function AllocationComparisonBlockView({ block, ...rest }: Props) {
  return (
    <BlockShell blockId={block.id} slug={block.slug} {...rest}>
      <AllocationComparison
        before={block.before}
        after={block.after}
        provisional={block.provisional}
        provisionalReason={block.provisional_reason ?? undefined}
      />
    </BlockShell>
  )
}
